// extracted by mini-css-extract-plugin
export var detailsGdd = "detailsGdd-module--details-gdd--038b5";
export var preLink = "detailsGdd-module--pre-link--51dc4";